import { locale as datesLocale } from "dayjs";
import { useTranslation } from "react-i18next";

import { useRouter } from "@tanstack/react-router";

import { useAuthSession, useUpdateAuthUserProfile } from "@/api/resources/auth/hooks";
import LocaleSelector from "@/components/Locale/LocaleSelector";

export const LocaleSelectorGlobal = () => {
  const router = useRouter();
  const { data: session } = useAuthSession();
  const { mutate: updateAuthUserProfile, isPending: loadingUpdateAuthUserProfile } = useUpdateAuthUserProfile();
  const { i18n } = useTranslation();

  const currentLocale = i18n.resolvedLanguage;

  const onLocaleChange = async (locale: string | null) => {
    if (locale) {
      await i18n.changeLanguage(locale);
      await router.invalidate();

      datesLocale(locale);
      if (session) {
        updateAuthUserProfile({
          id: session.user.id,
          locale,
        });
      }
    }
  };

  return (
    <LocaleSelector
      w="8rem"
      size="xs"
      required
      value={currentLocale}
      loading={loadingUpdateAuthUserProfile}
      onChange={onLocaleChange}
    />
  );
};

export default LocaleSelectorGlobal;
